import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  styled,
  makeStyles,
  ButtonGroup,
  RadioGroup,
  Radio,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import { useFormik, validateYupSchema } from "formik";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import Textarea from "@mui/joy/Textarea";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";
import * as Yup from "yup";
import FormProfileComponent from "./FormProfileComponent";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import InvitedUserComponent from "./InvitedUserComponent";
import TvideoComponent from "./TvideoComponent";
import TournamentGoalForm from "./TournamentGoalForms/Index";
import { generateRandomNumber } from "../../../helper/generateRandom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const tournamentAllowedCat = ["Men's Football", "Women's Football"];

const CustomTextarea = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #414466",
    borderRadius: "8px",
    color: "white",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
      outline: "none",
    },

    [theme.breakpoints.down("md")]: {
      padding: "7.5px 9px",
    },

    "& .MuiInputBase-input": {
      // maxHeight: "70px",
      [theme.breakpoints.down("md")]: {
        maxHeight: "52px",

        padding: "0px",
      },
      "&.Mui-disabled": {
        WebkitTextFillColor: "inherit",
        cursor: "not-allowed !important",
      },
    },

    "&.Mui-disabled": {
      backgroundColor: "rgba(255,255,255,0.04) !important",
      border: "1px solid #2f3250 !important",
      color: "rgba(255,255,255,0.4) !important",
      cursor: "not-allowed !important",
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const StyledRadio = styled(Radio)(({ theme }) => ({
  color: "white",
  padding: "0",
  "&.Mui-checked": {
    color: "#343759",
  },
  "&.MuiRadio-root": {
    padding: "0",
    /*  DISABLED */
    "&.Mui-disabled": {
      color: "rgba(255,255,255,0.4)",
      cursor: "not-allowed",
    },

    "&.Mui-checked.Mui-disabled": {
      color: "rgba(52,55,89,0.5)",
    },
  },
}));

const StyledRadioD = styled(Radio)(({ theme }) => ({
  display: "none",

  "&.Mui-disabled": {
    pointerEvents: "none",
  },
}));

const StyledRadioLable = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "checked",
})(({ theme, checked, disabled }) => ({
  gap: "10px",
  alignItems: "center",
  margin: theme.spacing(1),
  padding: "15px 20px",
  // backgroundColor: checked ? "#FFCD1F" : "#343759",
  borderRadius: "40px",
  cursor: "pointer",

  // color: checked ? "black" : "#ffffff",
  padding: "15px 20px",

  cursor: disabled ? "not-allowed !important" : "pointer",

  backgroundColor: disabled
    ? checked
      ? "rgba(255,205,31,0.4)"
      : "#2a2d4a"
    : checked
      ? "#FFCD1F"
      : "#343759",

  color: disabled
    ? checked
      ? "rgba(0,0,0,0.6)"
      : "rgba(255,255,255,0.4)"
    : checked
      ? "black"
      : "#ffffff",

  opacity: 1,
  [theme.breakpoints.down("md")]: {
    padding: "8px 11px",
    fontSize: "14px",
  },

  textTransform: "none",

  "& .Mui-checked ": {
    backgroundColor: "#FFCD1F",
    color: "black",
  },

  "& .MuiFormControlLabel-label": {
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
  },
}));

const categories = [
  { id: 1, name: "Men's" },
  { id: 2, name: "Women's" },
  { id: 3, name: "Boy's" },
  { id: 4, name: "Girl's" },
  { id: 5, name: "Vet's" },
];

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

const Form1 = ({
  formik,
  setFinalInvitedUsers,
  finalInvitedUsers,
  edited,
  editTableVideo,
  deletedVideos,
  setDeletedVideos,
  goalVideos,
  setGoalVideos,
  setErrorState,
  setFormErrors,
  addTournamentFormSubmited,
  isAdmin,
}) => {
  const [goalLoading, setGoalLoading] = useState(false);
  const goalCategories = useSelector((state) => state.goalCategories);

  return (
    <>
      <Box className="addGoal-form">
        <Box className="profile-wrapper">
          <FormProfileComponent
            formik={formik}
            edited={edited}
            isAdmin={isAdmin}
          />
        </Box>

        <Box className="category form-control">
          <Typography className="label">Name</Typography>
          <CustomTextarea
            variant="outlined"
            name="title"
            value={formik.values.title}
            onChange={formik.handleChange}
            placeholder="Enter Tournament Name"
            disabled={!isAdmin}
          />
          {formik.touched.title && formik.errors.title ? (
            <FormHelperText sx={{ color: "red" }}>
              {formik.errors.title}
            </FormHelperText>
          ) : (
            ""
          )}
        </Box>

        <Box className="title form-control">
          <Typography className="label">Description</Typography>
          <CustomTextarea
            id="outlined-multiline-static"
            rows={5}
            multiline
            placeholder="Enter tournament information"
            variant="outlined"
            value={formik.values.description}
            onChange={formik.handleChange}
            name="description"
            disabled={!isAdmin}
          />

          {formik.touched.description && formik.errors.description ? (
            <FormHelperText sx={{ color: "red" }}>
              {formik.errors.description}
            </FormHelperText>
          ) : (
            ""
          )}
        </Box>

        <Box className="category form-control">
          <Typography className="label">Video Category</Typography>
          <RadioGroup name="category" row disabled={!isAdmin}>
            {!goalCategories.loading
              ? goalCategories.data.data
                  ?.filter(
                    (category) =>
                      category.enable &&
                      tournamentAllowedCat.includes(category.name),
                  )
                  .map((category) => (
                    <StyledRadioLable
                      control={
                        <StyledRadioD
                          value={category.id}
                          onChange={formik.handleChange}
                          checked={formik.values.category === category.id}
                          disabled={!isAdmin}
                        />
                      }
                      label={category.name}
                      checked={formik.values.category === category.id}
                      key={category.id}
                      onClick={() => {
                        if (isAdmin) {
                          formik.setFieldValue("category", category.id);
                          formik.setFieldValue("subCategory", null);
                          formik.setFieldValue("childCategory", null);
                          formik.setFieldTouched("category", true);
                        }
                      }}
                      disabled={!isAdmin}
                    />
                  ))
              : ".....loading"}
          </RadioGroup>
          {formik.touched.category && formik.errors.category ? (
            <FormHelperText sx={{ color: "red" }}>
              {formik.errors.category}
            </FormHelperText>
          ) : (
            ""
          )}
        </Box>

        {formik.values.category == "6" && (
          <>
            <Box className="category form-control">
              <Typography className="label">Youth Category</Typography>
              <RadioGroup name="subCategory" row disabled={!isAdmin}>
                {goalCategories.loading ? (
                  <CircularProgress sx={{ color: "#ef364e" }} />
                ) : goalCategories.data?.data?.length > 0 ? (
                  goalCategories.data.data
                    ?.filter((cat) => cat.enable)
                    .find((cat) => cat.id == "6")
                    ?.subCategory?.map((category, index) => (
                      <StyledRadioLable
                        control={
                          <StyledRadioD
                            value={category.id}
                            onChange={formik.handleChange}
                            checked={formik.values.subCategory === category.id}
                          />
                        }
                        label={category.name}
                        checked={formik.values.subCategory === category.id}
                        key={category.id}
                        onClick={() => {
                          if (isAdmin) {
                            formik.setFieldValue("subCategory", category.id);
                            formik.setFieldTouched("subCategory", true);
                          }
                        }}
                        disabled={!isAdmin}
                      />
                    ))
                ) : null}
              </RadioGroup>
              {formik.touched.subCategory && formik.errors.subCategory ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.touched.subCategory && formik.errors.subCategory}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>
            <Box className="category form-control">
              <Typography className="label">Category</Typography>
              <RadioGroup name="subCategory" row disabled={!isAdmin}>
                {goalCategories.loading ? (
                  <CircularProgress sx={{ color: "#ef364e" }} />
                ) : goalCategories.data?.data?.length > 0 ? (
                  goalCategories.data.data
                    ?.filter((cat) => cat.enable)
                    .find((cat) => cat.id == "6")
                    ?.subCategory?.find(
                      (subc) => subc.id == formik.values.subCategory,
                    )
                    ?.childSubCategories?.map((category, index) => (
                      <>
                        <StyledRadioLable
                          control={
                            <StyledRadioD
                              value={category.id}
                              onChange={formik.handleChange}
                              checked={
                                formik.values.childCategory === category.id
                              }
                              disabled={!isAdmin}
                            />
                          }
                          label={category.name}
                          checked={formik.values.childCategory === category.id}
                          key={category.id}
                          onClick={() => {
                            if (isAdmin) {
                              formik.setFieldValue(
                                "childCategory",
                                category.id,
                              );
                              formik.setFieldTouched("childCategory", true);
                            }
                          }}
                          disabled={!isAdmin}
                        />
                      </>
                    ))
                ) : null}
              </RadioGroup>
              {formik.touched.childCategory &&
              formik.errors.childCategory &&
              formik.values.subCategory ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.touched.childCategory && formik.errors.childCategory}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>
          </>
        )}

        <Box className="category form-control">
          <Typography className="label">Video From</Typography>
          <RadioGroup name="from_uk" row disabled={!isAdmin}>
            {[
              { name: "UK", id: 1 },
              { name: "International", id: 0 },
            ].map((category) => (
              <StyledRadioLable
                control={
                  <StyledRadio
                    value={category.id}
                    onChange={(e) => {
                      if (e.target.checked)
                        formik.setFieldValue("from_uk", category.id);
                    }}
                    checked={formik.values.from_uk === category.id}
                    disabled={!isAdmin}
                  />
                }
                label={category.name}
                checked={formik.values.from_uk === category.id}
                key={category.id}
                onClick={() => {
                  if (isAdmin) {
                    formik.setFieldValue("from_uk", category.id);
                    formik.setFieldTouched("from_uk", true);
                  }
                }}
                disabled={!isAdmin}
              />
            ))}
          </RadioGroup>
          {formik.touched.from_uk && formik.errors.from_uk ? (
            <FormHelperText sx={{ color: "red" }}>
              {formik.errors.from_uk}
            </FormHelperText>
          ) : (
            ""
          )}
        </Box>

        <Box className="category form-control">
          <Typography className="label">City/Town</Typography>
          <CustomTextarea
            variant="outlined"
            name="region"
            value={formik.values.region}
            onChange={formik.handleChange}
            placeholder="Enter City/Town"
            disabled={!isAdmin}
          ></CustomTextarea>
          {formik.touched.region && formik.errors.region ? (
            <FormHelperText sx={{ color: "red" }}>
              {formik.errors.region}
            </FormHelperText>
          ) : (
            ""
          )}
        </Box>

        <Box className="category form-control">
          <Typography className="label">Tournament Organizers</Typography>
          <CustomTextarea
            variant="outlined"
            name="club"
            value={formik.values.club}
            onChange={formik.handleChange}
            placeholder="Enter Tournament Organizers"
            disabled={!isAdmin}
          />
          {formik.touched.club && formik.errors.club ? (
            <FormHelperText sx={{ color: "red" }}>
              {formik.errors.club}
            </FormHelperText>
          ) : (
            ""
          )}
        </Box>

        <Box className="category form-control">
          <Typography className="label">Visibility/Access</Typography>
          <RadioGroup name="from_uk" row disabled={!isAdmin}>
            {[
              {
                name: "Public",
                id: 1,
                icon: <LockOpenIcon sx={{ fontSize: "20px" }} />,
              },
              {
                name: "Private",
                id: 0,
                icon: <LockIcon sx={{ fontSize: "20px" }} />,
              },
            ].map((category) => (
              <StyledRadioLable
                control={
                  <>
                    {category.icon}
                    <StyledRadioD
                      value={category.id}
                      onChange={formik.handleChange}
                      checked={formik.values.visibility === category.id}
                      disabled={!isAdmin}
                    />
                  </>
                }
                label={category.name}
                checked={formik.values.visibility === category.id}
                key={category.id}
                onClick={() => {
                  if (isAdmin) {
                    formik.setFieldValue("visibility", category.id);
                  }
                }}
                disabled={!isAdmin}
              />
            ))}
          </RadioGroup>
          {formik.touched.visibility && formik.errors.visibility ? (
            <FormHelperText sx={{ color: "red" }}>
              {formik.errors.visibility}
            </FormHelperText>
          ) : (
            ""
          )}
        </Box>
      </Box>

      <Box className="invite-user-div">
        <InvitedUserComponent
          setFinalInvitedUsers={setFinalInvitedUsers}
          finalInvitedUsers={finalInvitedUsers}
          isAdmin={isAdmin}
          formik={formik}
        />
        {/* <FormHelperText sx={{ color: "red" }}>
          {finalInvitedUsers !== null && finalInvitedUsers.length == 0
            ? "Please Invite at least one user"
            : ""}
        </FormHelperText> */}
      </Box>

      <Box className="category form-control">
        <Typography className="label">Add Goal Videos</Typography>
        <Box className="goal_videos_preview">
          <TournamentGoalForm
            setDeletedVideos={setDeletedVideos}
            goalVideos={goalVideos}
            setGoalVideos={setGoalVideos}
            addTournamentFormSubmited={addTournamentFormSubmited}
            isAdmin={isAdmin}
          />
          <Button
            style={{
              border: "1px solid #46496a",
              borderRadius: "8px",
              backgroundColor: "#FFCD1F",
              color: "black",
              padding: "8px 13px",
              marginTop: "20px",
              textTransform: "capitalize",
            }}
            onClick={() => {
              if (goalLoading) {
                return;
              }

              if (goalVideos.length >= 20) {
                toast.error("Maximum limit has been reached!!");
                return;
              }

              setGoalVideos((prev) => {
                return [
                  ...prev,
                  {
                    key_Id: generateRandomNumber(5),
                    club_name: "",
                    goal_scorer: "",
                    club_img: "",
                    goal: null,
                    validated: false,
                    error: "",
                  },
                ];
              });
            }}
          >
            Add More Goal
          </Button>
        </Box>
      </Box>

      {/* <TvideoComponent
        formik={formik}
        edited={edited}
        editTableVideo={editTableVideo}
        deletedVideos={deletedVideos}
        setDeletedVideos={setDeletedVideos}
      /> */}
    </>
  );
};

export default Form1;
